import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { once as c } from "../../../utils/once.js";
import { disposables as f } from "../../../utils/disposables.js";
import { match as u } from "../../../utils/match.js";

function p(t) {
  var _t$classList;

  for (var _len = arguments.length, e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    e[_key - 1] = arguments[_key];
  }

  t && e.length > 0 && (_t$classList = t.classList).add.apply(_t$classList, e);
}

function v(t) {
  var _t$classList2;

  for (var _len2 = arguments.length, e = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    e[_key2 - 1] = arguments[_key2];
  }

  t && e.length > 0 && (_t$classList2 = t.classList).remove.apply(_t$classList2, e);
}

var g = function (n) {
  return n.Ended = "ended", n.Cancelled = "cancelled", n;
}(g || {});

function T(t, e) {
  var n = f();
  if (!t) return n.dispose;

  var _getComputedStyle = getComputedStyle(t),
      l = _getComputedStyle.transitionDuration,
      a = _getComputedStyle.transitionDelay,
      _map = [l, a].map(function (i) {
    var _i$split$filter$map$s = i.split(",").filter(Boolean).map(function (o) {
      return o.includes("ms") ? parseFloat(o) : parseFloat(o) * 1e3;
    }).sort(function (o, E) {
      return E - o;
    }),
        _i$split$filter$map$s2 = _slicedToArray(_i$split$filter$map$s, 1),
        _i$split$filter$map$s3 = _i$split$filter$map$s2[0],
        r = _i$split$filter$map$s3 === void 0 ? 0 : _i$split$filter$map$s3;

    return r;
  }),
      _map2 = _slicedToArray(_map, 2),
      d = _map2[0],
      s = _map2[1];

  if (d + s !== 0) {
    var i = [];
    i.push(n.addEventListener(t, "transitionrun", function () {
      i.splice(0).forEach(function (r) {
        return r();
      }), i.push(n.addEventListener(t, "transitionend", function () {
        e("ended"), i.splice(0).forEach(function (r) {
          return r();
        });
      }, {
        once: !0
      }), n.addEventListener(t, "transitioncancel", function () {
        e("cancelled"), i.splice(0).forEach(function (r) {
          return r();
        });
      }, {
        once: !0
      }));
    }, {
      once: !0
    }));
  } else e("ended");

  return n.add(function () {
    return e("cancelled");
  }), n.dispose;
}

function C(t, e, n, l) {
  var a = n ? "enter" : "leave",
      d = f(),
      s = l !== void 0 ? c(l) : function () {},
      m = u(a, {
    enter: function enter() {
      return e.enter;
    },
    leave: function leave() {
      return e.leave;
    }
  }),
      i = u(a, {
    enter: function enter() {
      return e.enterTo;
    },
    leave: function leave() {
      return e.leaveTo;
    }
  }),
      r = u(a, {
    enter: function enter() {
      return e.enterFrom;
    },
    leave: function leave() {
      return e.leaveFrom;
    }
  });
  return v.apply(void 0, [t].concat(_toConsumableArray(e.enter), _toConsumableArray(e.enterTo), _toConsumableArray(e.enterFrom), _toConsumableArray(e.leave), _toConsumableArray(e.leaveFrom), _toConsumableArray(e.leaveTo), _toConsumableArray(e.entered))), p.apply(void 0, [t].concat(_toConsumableArray(m), _toConsumableArray(r))), d.nextFrame(function () {
    v.apply(void 0, [t].concat(_toConsumableArray(r))), p.apply(void 0, [t].concat(_toConsumableArray(i))), T(t, function (o) {
      return o === "ended" && (v.apply(void 0, [t].concat(_toConsumableArray(m))), p.apply(void 0, [t].concat(_toConsumableArray(e.entered)))), s(o);
    });
  }), d.dispose;
}

export { g as Reason, C as transition };